.card {
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 20px;
  border: 0;
  border-radius: var(--radius-card);
  background: none;
  color: var(--ink);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

/* The accent dot says "new", as on the blueprint. */
.dot {
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  margin-top: 7px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  background: var(--accent);
}

.lines {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.title {
  font-size: 16px;
  font-weight: 600;
}

.session {
  font-size: 14px;
  color: var(--ink-2);
}

/* The note keeps the clinician's own paragraph breaks. */
.body {
  padding: 16px 20px 20px;
  border-top: 1.5px solid var(--ink);
  line-height: 1.55;
  white-space: pre-line;
}
